import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getUser } from "../store/user/action";
import { CreatorDetails } from "../component/dialog/CreatorDetails";
import useTranslation from "../hooks/useTranslation";
import { pageHeader, headerTitle, headerDesc } from "../util/theme";

const Creators = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const agencyId = localStorage.getItem("agencyId");

  useEffect(() => {
    dispatch(getUser(agencyId));
  }, [dispatch, agencyId]);

  return (
    <div
      className="page-container"
      style={{ background: "transparent", minHeight: "100vh", paddingBottom: 16 }}
    >
      <div className="page" style={{ background: "transparent" }}>
        <div style={{ maxWidth: 480, margin: "0 auto" }}>
          <div style={pageHeader}>
            <div style={headerTitle}>{t("host")}</div>
            <div style={headerDesc}>{t("manage_agency_view")}</div>
          </div>
          <CreatorDetails />
        </div>
      </div>
    </div>
  );
};

export default Creators;
